import { Paper, Box, Typography } from '@mui/material'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { makeStyles } from 'tss-react/mui'

import { Retrofit } from 'src/Libs/retrofit/models/retrofit.model'
import InstallerContact from './InstallerContact'
import CurrentSystemInfo from './CurrentSystemInfo'
import RetrofitRecommendations from './RetrofitRecommendations'

const useStyles = makeStyles()(theme => ({
  paperContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(4),
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },
  currentSystemInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),

    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(2),
    },
  },
  captionMessage: {
    marginTop: `-${theme.spacing(2)}`,
  },
}))

interface RetrofitAvailableProps {
  retrofitData: Retrofit
}

/**
 * Component to display, when there are retorfit options for a system
 */
const RetrofitAvailable: React.FC<RetrofitAvailableProps> = ({ retrofitData }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <Paper className={classes.paperContainer}>
      <Box className={classes.currentSystemInfo}>
        <InstallerContact retrofitData={retrofitData} />
        <CurrentSystemInfo retrofitData={retrofitData} />
        <Typography variant="caption" className={classes.captionMessage}>
          {t('retrofit-check.available.suggestions.max-capacity-warning')}
        </Typography>
      </Box>
      <RetrofitRecommendations retrofitData={retrofitData} />
    </Paper>
  )
}

export default RetrofitAvailable
